import { Link } from "react-router-dom";

export function GoldButton({ as = "button", to, children, variant = "solid", className = "", ...props }) {
  const base = "inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 text-sm font-semibold transition-all duration-300 gold-glow-hover";
  const styles = variant === "solid"
    ? "bg-gradient-to-r from-[#D4AF37] to-[#F0D77B] text-[#0A0A0A]"
    : "border border-[#D4AF37]/50 text-[#D4AF37] hover:text-[#0A0A0A] hover:bg-[#D4AF37]";
  const cls = `${base} ${styles} ${className}`;
  if (as === "link") return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (as === "a") return <a className={cls} {...props}>{children}</a>;
  return <button className={cls} {...props}>{children}</button>;
}

export function Section({ children, className = "", id }) {
  return (
    <section id={id} className={`mx-auto max-w-7xl px-4 sm:px-6 py-16 sm:py-24 ${className}`}>
      {children}
    </section>
  );
}
